import { render, staticRenderFns } from "./provider.vue?vue&type=template&id=68bc5a88"
import script from "./provider.js?vue&type=script&lang=js&external"
export * from "./provider.js?vue&type=script&lang=js&external"
import style0 from "./provider.vue?vue&type=style&index=0&id=68bc5a88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports